<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event.target.value)"
    fullscreen
    transition="dialog-bottom-transition"
  >
    <v-card color="primary" v-if="item.item">
      <AuditToolbar
        :title="item.item.pickslip"
        :item="item"
        :totalItems="item.totalItems"
        @handlePrevItem="$emit('handlePrevItem', item.index )"
        @handleNextItem="$emit('handleNextItem', item.index )"
        @exit="$emit('input', false)"
      />
      <v-card-text>
        <h2 class="pa-2 mt-5">Details</h2>
        <v-divider />
        <v-layout row class="mt-3">
          <v-flex>
            <h3 class="pa-2">Audit Date: {{ localizeDate(item.item.dateCreated, true) }}</h3>
            <h3 class="pa-2">Auditor: {{ item.item.auditor.name }}</h3>
            <h3 class="pa-2">Remarks: {{ item.item.remarks }}</h3>
          </v-flex>
        </v-layout>

        <h2 class="mt-4 pa-2">Products ({{ item.item.totalProductCount.toLocaleString() }})</h2>

        <v-divider />

        <v-layout row class="mt-4 pa-2 primary lighten-3">
          <v-flex xs3>
            <h3>Product</h3>
          </v-flex>
          <v-flex xs3>
            <h3 class="text-xs-center">Quantity</h3>
          </v-flex>
          <v-flex xs3>
            <h3>Result</h3>
          </v-flex>
          <v-flex xs3>
            <h3>Comment</h3>
          </v-flex>
        </v-layout>

        <v-divider />

        <div v-for="(product, index) in item.item.products" :key="index">
          <v-layout row :class="index % 2 ? 'primary lighten-1 pa-2' : 'pa-2'">
            <v-flex xs3>
              <h4>{{ product.sku }}</h4>
            </v-flex>
            <v-flex xs3>
              <h4 class="text-xs-center">{{ product.quantity }}</h4>
            </v-flex>
            <v-flex xs3>
              <h4
                :style="{ color: product.responses.yes ? 'green' : 'red' }"
              >{{ product.responses.yes ? "PASSED" : "FAILED" }}</h4>
            </v-flex>
            <v-flex xs3>
              <h4>{{ product.responses.comments }}</h4>
            </v-flex>
          </v-layout>
        </div>
        <h2 class="mt-4 pa-2">Chatter</h2>
        <v-divider />
        <Chatter v-if="chatterID" reload :id="chatterID" collection="shipping" color="primary" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import AuditToolbar from "../AuditToolbar";
import Chatter from "../../app/chatter";
import Common from "@/mixins/Common";

export default {
  name: "Audit",

  props: ["value", "item"],

  computed: {
    ...mapGetters({
      audits: "audits/getAllAudits",
      loading: "app/isLoading"
    }),
    chatterID() {
      return this.item.item._id || null;
    }
  },

  components: {
    AuditToolbar,
    Chatter
  },

  watch: {
    value(val) {
      if (!val) {
        let search = this.item.search;
        this.$store.dispatch("audits/getAllAudits", search);
      }
    }
  },

  mixins: [Common]
};
</script>
